import React, { useState } from "react";
import API from "./api/API";
import Authentication from "./api/Authentication/Authentication";

const VerificationAwaiting = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [updated, setUpdated] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const user = Authentication.getCurrentUser();

      if (user) {
        // Call API to update the user's email for verification notifications.
        const result = await API.updateEmail(user._id, email);
        if (result.data.success) {
          setMessage(
            "The scribes have been notified! Soon, you shall receive a dispatch when your account is blessed by the High Lords of Terra."
          );
          setUpdated(true);
        } else {
          setError("The machine spirit is troubled – please try again.");
        }
      }
    } catch (err) {
      setError("An error occurred in the void. Please try again.");
    }
  };

  return (
    <div className="min-h-[100dvh] bg-black text-white flex items-center justify-center p-6">
      <div className="max-w-md bg-gray-800 p-8 rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold mb-4 text-center">
          Awaiting Verification
        </h1>
        <p className="mb-6 text-center text-sm">
          The Emperor watches over you, but your account awaits His sanction.
          Your status is pending the approval of the Adeptus Administratum.
          Enter your e-mail below to receive the sacred dispatch when your account is elevated.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 mb-4 rounded bg-gray-700 border border-gray-600 focus:outline-none focus:ring focus:border-blue-500"            
            disabled={updated}
            required
          />
          <button
            type="submit"
            className="w-full bg-blue-500 hover:bg-blue-600 p-3 rounded font-bold transition duration-300"            
            disabled={updated}
          >
            {updated ? 'The Emperor Protects!':'Send Dispatch'}
            
          </button>
        </form>
        {message && (
          <p className="mt-4 text-center text-green-400 text-sm">{message}</p>
        )}
        {error && (
          <p className="mt-4 text-center text-red-400 text-sm">{error}</p>
        )}
      </div>
    </div>
  );
};

export default VerificationAwaiting;